import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "h-full py-6 my-3 transition-shadow duration-75 ease-in-out card shadow-elevation hover-shadow-elevation-2" }
const _hoisted_2 = { class: "flex flex-col w-full md:items-center md:flex-row" }
const _hoisted_3 = { class: "flex md:w-1/3 md:mr-auto" }
const _hoisted_4 = {
  key: 0,
  class: "my-auto mr-2 text-lg cursor-move drag-handle material-icons-outlined opacity-70"
}
const _hoisted_5 = {
  key: 0,
  class: "ml-2 text-muted"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  style: {"font-size":"17px"},
  class: "material-icons"
}, " delete ", -1)
const _hoisted_7 = { class: "flex flex-col w-full my-auto md:space-x-2 md:items-center md:flex-row md:ml-auto" }
const _hoisted_8 = { class: "flex space-x-1" }
const _hoisted_9 = { class: "flex items-center space-x-2" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons mr-1.5" }, " settings ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  style: {"font-size":"17px"},
  class: "material-icons"
}, " delete ", -1)
const _hoisted_13 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_14 = { class: "mb-2 text-muted" }
const _hoisted_15 = {
  key: 0,
  class: "mb-2 text-muted"
}
const _hoisted_16 = {
  key: 1,
  class: "mb-2 text-muted"
}
const _hoisted_17 = { class: "flex xl:flex-row flex-col xl:space-x-3" }
const _hoisted_18 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl text-muted" }, "(", -1)
const _hoisted_20 = {
  key: 1,
  class: "text-xl text-muted"
}
const _hoisted_21 = { key: 2 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, " restart_alt ", -1)
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "grid grid-cols-1 mt-6 md:grid-cols-3" }
const _hoisted_25 = { class: "flex items-center justify-center space-x-3" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "opacity-50 material-icons" }, " topic ", -1)
const _hoisted_27 = { class: "" }
const _hoisted_28 = {
  style: {"letter-spacing":"0.25px"},
  class: "font-normal"
}
const _hoisted_29 = { class: "flex items-center justify-center space-x-3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "opacity-50 material-icons-outlined" }, " shuffle ", -1)
const _hoisted_31 = { class: "" }
const _hoisted_32 = {
  style: {"letter-spacing":"0.25px"},
  class: "font-normal"
}
const _hoisted_33 = { class: "flex items-center justify-center space-x-3" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "opacity-50 material-icons" }, " label ", -1)
const _hoisted_35 = { class: "" }
const _hoisted_36 = {
  style: {"letter-spacing":"0.25px"},
  class: "font-normal"
}
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "text-dark" }
const _hoisted_39 = {
  class: "mt-4",
  style: {"height":"calc(100vh - 224px)"}
}
const _hoisted_40 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_NumberInput = _resolveComponent("NumberInput")!
  const _component_MinimalExercisePreview = _resolveComponent("MinimalExercisePreview")!
  const _component_SkeletonCard = _resolveComponent("SkeletonCard")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_ExercisePicker = _resolveComponent("ExercisePicker")!
  const _component_TagBasedEventTemplateRuleEditor = _resolveComponent("TagBasedEventTemplateRuleEditor")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (!_ctx.randomOrder)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, " drag_indicator "))
            : _createCommentVNode("", true),
          _createElementVNode("h4", {
            class: _normalizeClass([{ 'text-danger-dark': _ctx.v$.$errors.length > 0 }, ""])
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t("event_template_rule_editor.exercise_number")) + " " + _toDisplayString(_ctx.displayedOrdering) + " ", 1),
            (_ctx.modelValue.amount > 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "(" + _toDisplayString(_ctx.modelValue.amount + " " + _ctx.$t("misc.slots")) + ")", 1))
              : _createCommentVNode("", true)
          ], 2),
          _createVNode(_component_Btn, {
            tooltip: _ctx.$t('misc.delete'),
            variant: 'icon',
            outline: true,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('deleteRule'))),
            class: "ml-auto -mt-2 -mr-3 transition-opacity duration-100 opacity-50 md:hidden hover:opacity-100"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["tooltip"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_NumberInput, {
            min: 0,
            class: _normalizeClass(["my-4 md:ml-auto md:my-0", { 'md:w-1/4': !_ctx.reduced, 'md:w-1/3': _ctx.reduced }]),
            modelValue: _ctx.modelValue.weight ?? 0,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.emitUpdate('weight', $event)))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("event_template_rule_editor.weight")), 1),
                _createVNode(_component_Tooltip, {
                  placement: 'top',
                  class: "transform scale-125",
                  "text-code": 'event_template_rule_editor.weight'
                }, null, 8, ["text-code"])
              ])
            ]),
            _: 1
          }, 8, ["class", "modelValue"]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Btn, {
              variant: 'secondary',
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showRuleDialog())),
              size: 'sm',
              class: "w-full"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createTextVNode(_toDisplayString(_ctx.$t("event_template_rule_editor.choose_exercise")), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Btn, {
              tooltip: _ctx.$t('misc.delete'),
              variant: 'icon',
              outline: true,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('deleteRule'))),
              class: "hidden transition-opacity duration-100 opacity-50 md:block hover:opacity-100"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["tooltip"])
          ])
        ])
      ]),
      (_ctx.isSlotPopulated && _ctx.modelValue.rule_type == _ctx.EventTemplateRuleType.ID_BASED)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.ruleExercises.length == 1
							? _ctx.$t("event_template_rule_editor.same_exercise_for_everyone_description")
							: _ctx.$t("event_template_rule_editor.one_exercise_from_set_description")), 1),
            _createElementVNode("div", null, [
              (!_ctx.loadingPreview)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass([
							_ctx.ruleExercises.length > 1
								? _ctx.reduced
									? 'flex flex-wrap'
									: 'grid md:grid-cols-2 gap-2'
								: '',
							'overflow-x-auto md:overflow-visible',
						])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ruleExercises, (exercise) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'r-' + _ctx.modelValue.id + '-e-' + exercise.id
                      }, [
                        _createVNode(_component_MinimalExercisePreview, {
                          reduced: _ctx.reduced,
                          exercise: exercise,
                          selectable: false,
                          showEdit: false,
                          class: _normalizeClass({ 'mr-6': _ctx.reduced }),
                          onEdit: ($event: any) => (
									_ctx.$router.push({
										name: 'CourseExercises',
										hash: '#editor-' + exercise.id,
									})
								)
                        }, null, 8, ["reduced", "exercise", "class", "onEdit"])
                      ]))
                    }), 128))
                  ], 2))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass([
							_ctx.ruleExercises.length > 1 ? 'grid md:grid-cols-2 gap-2' : '',
							'overflow-x-auto md:overflow-visible',
						])
                  }, [
                    _createVNode(_component_SkeletonCard, { short: true }),
                    (_ctx.ruleExercises.length > 1)
                      ? (_openBlock(), _createBlock(_component_SkeletonCard, {
                          key: 0,
                          short: true
                        }))
                      : _createCommentVNode("", true)
                  ], 2))
            ])
          ]))
        : (
					_ctx.isSlotPopulated && _ctx.modelValue.rule_type == _ctx.EventTemplateRuleType.TAG_BASED
				)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["mt-4", { 'opacity-40': _ctx.v$.$errors.length > 0 }])
            }, [
              (_ctx.modelValue.amount === 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.$t("event_template_rule_editor.tag_based_description")), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_16, [
                    _createTextVNode(_toDisplayString(_ctx.$t("event_template_rule_editor.tag_based_description_multiple_1") + " "), 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.modelValue.amount), 1),
                    _createTextVNode(" " + _toDisplayString(" " + _ctx.$t("event_template_rule_editor.tag_based_description_multiple_2")), 1)
                  ])),
              _createElementVNode("div", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue.clauses, (clause, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'clause-preview-' + clause.id,
                    class: "flex items-center mb-2 flex-wrap"
                  }, [
                    (clause.tags.length > 1)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                          _createTextVNode(_toDisplayString(_ctx.$t("event_template_rule_editor.tag_based_at_least_one")) + " " + _toDisplayString(_ctx.$t("misc.among")) + " ", 1),
                          _hoisted_19
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clause.tags, (tag, index) => {
                      return (_openBlock(), _createBlock(_component_Tag, {
                        class: _normalizeClass(["mx-0.5", { '-ml-1.5': index === 0 }]),
                        key: 'clause-' + clause.id + '-tag-' + tag.id,
                        tag: tag
                      }, null, 8, ["class", "tag"]))
                    }), 128)),
                    (clause.tags.length > 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, ")"))
                      : _createCommentVNode("", true),
                    (index !== _ctx.modelValue.clauses.length - 1)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_21, ","))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ], 2))
          : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.$errors, (error) => {
        return (_openBlock(), _createElementBlock("p", {
          class: "text-danger-dark",
          key: _ctx.modelValue.id + '-' + error.$uid
        }, _toDisplayString(_ctx.$t("validation_errors.eventTemplateRule." + error.$uid)), 1))
      }), 128))
    ]),
    _createVNode(_component_Dialog, {
      showDialog: _ctx.showDialog,
      fullWidth: true,
      fullHeight: _ctx.modelValue.rule_type === _ctx.EventTemplateRuleType.ID_BASED,
      headerBorder: _ctx.modelValue.rule_type === _ctx.EventTemplateRuleType.ID_BASED,
      stickyHeader: _ctx.modelValue.rule_type === _ctx.EventTemplateRuleType.ID_BASED,
      footerBorder: true,
      confirmOnly: true,
      onYes: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onCloseDialog()))
    }, _createSlots({
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString((_ctx.modelValue.amount === 1
						? _ctx.$t("event_template_rule_editor.populate_slot_singular_title")
						: _ctx.$t("event_template_rule_editor.populate_slot_plural_title")) +
					" " +
					_ctx.displayedOrdering), 1)
      ]),
      body: _withCtx(() => [
        (_ctx.modelValue.rule_type == null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("event_template_rule_editor.mode_selection_text")), 1),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_Btn, {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setRuleMode(_ctx.EventTemplateRuleType.ID_BASED, true))),
                  variant: 'transparent',
                  class: "pb-4 border-b md:py-5 md:pl-4 md:border-r md:border-b-0"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("h4", _hoisted_27, _toDisplayString(_ctx.$t("event_template_rule_editor.pick_single_exercise")), 1)
                    ]),
                    _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$t("event_template_rule_editor.pick_single_exercise_help_text")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Btn, {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setRuleMode(_ctx.EventTemplateRuleType.ID_BASED, false))),
                  variant: 'transparent',
                  class: "py-4 border-b md:pl-4 md:pr-3 md:py-0 md:border-r md:border-b-0"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("h4", _hoisted_31, _toDisplayString(_ctx.$t("event_template_rule_editor.pick_exercise_from_pool")), 1)
                    ]),
                    _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t("event_template_rule_editor.pick_exercise_from_pool_help_text")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Btn, {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setRuleMode(_ctx.EventTemplateRuleType.TAG_BASED))),
                  variant: 'transparent',
                  class: "pt-4 md:pl-8 md:pt-0 md:pr-6"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createElementVNode("h4", _hoisted_35, _toDisplayString(_ctx.$t("event_template_rule_editor.pick_exercise_tag_based")), 1)
                    ]),
                    _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$t("event_template_rule_editor.pick_exercise_tag_based_help_text")), 1)
                  ]),
                  _: 1
                })
              ])
            ]))
          : (_ctx.modelValue.rule_type == _ctx.EventTemplateRuleType.ID_BASED)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createElementVNode("h3", _hoisted_38, _toDisplayString(_ctx.pickOneExerciseOnly
								? _ctx.$t("event_template_rule_editor.pick_single_exercise")
								: _ctx.$t("event_template_rule_editor.pick_exercise_from_pool")), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.pickOneExerciseOnly
								? _ctx.$t("event_template_rule_editor.pick_single_exercise_help_text")
								: _ctx.$t("event_template_rule_editor.pick_exercise_from_pool_help_text")), 1),
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_component_ExercisePicker, {
                    modelValue: _ctx.modelValue.exercises,
                    alreadySelected: _ctx.globallySelectedExercises,
                    onAddExercise: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onAddExercise($event))),
                    onRemoveExercise: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onRemoveExercise($event)))
                  }, null, 8, ["modelValue", "alreadySelected"])
                ])
              ]))
            : (_ctx.modelValue.rule_type == _ctx.EventTemplateRuleType.TAG_BASED)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createVNode(_component_TagBasedEventTemplateRuleEditor, {
                    modelValue: _ctx.modelValue.clauses,
                    satisfying: _ctx.modelValue.satisfying,
                    onAddClause: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('addClause'))),
                    onDeleteClause: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('deleteClause', $event))),
                    onUpdateClause: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('updateClause', $event)))
                  }, null, 8, ["modelValue", "satisfying"])
                ]))
              : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (_ctx.modelValue.rule_type != null && !_ctx.lockRuleType)
        ? {
            name: "backButton",
            fn: _withCtx(() => [
              _createVNode(_component_Btn, {
                variant: 'icon',
                outline: true,
                size: 'lg',
                tooltip: _ctx.$t('event_template_rule_editor.reset_slot_settings'),
                class: "-ml-3.5 mt-1.25px",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setRuleMode(null)))
              }, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              }, 8, ["tooltip"])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["showDialog", "fullHeight", "headerBorder", "stickyHeader"])
  ]))
}